import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const PURCHASES = [{
  name: 'María',
  city: 'Buenos Aires',
  time: '3 minutos'
}, {
  name: 'Juan',
  city: 'Córdoba',
  time: '7 minutos'
}, {
  name: 'Lucía',
  city: 'Rosario',
  time: '12 minutos'
}, {
  name: 'Pedro',
  city: 'Mendoza',
  time: '5 minutos'
}, {
  name: 'Ana',
  city: 'La Plata',
  time: '9 minutos'
}, {
  name: 'Diego',
  city: 'Tucumán',
  time: '2 minutos'
}, {
  name: 'Florencia',
  city: 'Mar del Plata',
  time: '15 minutos'
}, {
  name: 'Martín',
  city: 'Salta',
  time: '6 minutos'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle logic
    const cycleInterval = setInterval(() => {
      if (isDismissed) return;
      setIsVisible(false); // Hide current
      setTimeout(() => {
        if (isDismissed) return;
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setIsVisible(true); // Show next
      }, 2000); // Wait 2s before showing next
    }, 8000); // Change every 8s (includes display time)
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, [isDismissed]);
  // Auto-hide after 5 seconds of being visible
  useEffect(() => {
    if (isVisible && !isDismissed) {
      const hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(hideTimeout);
    }
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  const currentPurchase = PURCHASES[currentIndex];
  return <AnimatePresence data-id="element-199">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -20
    }} transition={{
      duration: 0.5
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full" data-id="element-200">
          <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-start gap-3 relative overflow-hidden" data-id="element-201">
            <button onClick={() => setIsDismissed(true)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600 p-1" data-id="element-202">
              <X size={14} data-id="element-203" />
            </button>

            <div className="flex-shrink-0 relative" data-id="element-204">
              <img src="https://cdn.magicpatterns.com/uploads/48ZekWaPRLErh247wMWT3x/CONJUNTO_DE_MOCKUPS_TECNOLOGIA.png" alt="Product" className="w-12 h-12 object-cover rounded-md border border-gray-100" data-id="element-205" />
              <div className="absolute -bottom-1 -right-1 bg-green-500 rounded-full p-0.5 border-2 border-white" data-id="element-206">
                <CheckCircle2 size={10} className="text-white" data-id="element-207" />
              </div>
            </div>

            <div className="flex-1 pr-4" data-id="element-208">
              <p className="text-sm font-bold text-gray-800 leading-tight" data-id="element-209">
                {currentPurchase.name} de {currentPurchase.city}
              </p>
              <p className="text-xs text-gray-600 mt-0.5" data-id="element-210">
                compró el Kit hace{' '}
                <span className="font-medium text-green-600" data-id="element-211">
                  {currentPurchase.time}
                </span>
              </p>
              <div className="flex items-center mt-1" data-id="element-212">
                <div className="flex" data-id="element-213">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#fbbf24] text-[10px]" data-id="element-214">
                      ★
                    </span>)}
                </div>
                <span className="text-[10px] text-gray-400 ml-1" data-id="element-215">
                  Verificado
                </span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}